/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {rescheduleAppointment} from '../api'

export const useMutationRescheduleAppointment = createReactQueryMutationHook('rescheduleAppointment', rescheduleAppointment)
